import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Layers, Heart, Eye, CheckCircle } from 'lucide-react';
const steps = [{
  id: 1,
  title: 'Separas tu dinero al recibir la quincena',
  icon: Mail,
  color: 'yellow'
}, {
  id: 2,
  title: 'Lo distribuyes en sobres claros',
  icon: Layers,
  color: 'yellow'
}, {
  id: 3,
  title: 'Ves exactamente cuánto tienes',
  icon: Eye,
  color: 'yellow'
}, {
  id: 4,
  title: 'Decides con calma',
  icon: Heart,
  color: 'yellow'
}, {
  id: 5,
  title: 'Ajustas sin culpa',
  icon: CheckCircle,
  color: 'yellow'
}];
export function JourneySteps() {
  return <section className="py-12 bg-aged-green relative overflow-hidden" data-id="element-133">
      <div className="container mx-auto px-4" data-id="element-134">
        <div className="text-center mb-16" data-id="element-135">
          <h2 className="text-4xl md:text-5xl font-bold text-[#f4c430] mb-4 text-stroke-black-lg" style={{
          filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.5)) drop-shadow(0 8px 16px rgba(0,0,0,0.4)) drop-shadow(0 12px 24px rgba(0,0,0,0.3))'
        }} data-id="element-136">
            Cómo funciona (sin complicaciones)
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-6 mb-12" data-id="element-137">
          {steps.map((step, index) => <motion.div key={step.id} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center gap-6 bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 relative overflow-hidden" data-id="element-138">
              <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent pointer-events-none" data-id="element-139" />
              <div className="w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0 bg-[#f4c430] text-yellow-800 shadow-lg relative z-10" data-id="element-140">
                <step.icon size={28} strokeWidth={2} data-id="element-141" />
              </div>
              <div className="flex-1 relative z-10" data-id="element-142">
                <div className="text-sm font-bold uppercase tracking-wider text-white/60 mb-1" data-id="element-143">
                  Paso {step.id}
                </div>
                <h3 className="text-xl font-bold text-white" data-id="element-144">{step.title}</h3>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center max-w-2xl mx-auto space-y-4" data-id="element-145">
          <p className="text-2xl font-bold text-white" data-id="element-146">Eso es todo.</p>
          <p className="text-lg text-white/90" data-id="element-147">
            No hay fórmulas raras. No hay términos financieros. No hay castigo.
          </p>
        </div>
      </div>
    </section>;
}